import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { RideStationType } from "@ryde/shared";
import { greyMui, rydeColors } from "@ryde/theme";

export interface IRideStationInOutIcon {
  statusType: RideStationType;
  isGreyed: boolean;
}

export const RideStationInOutIcon: FC<IRideStationInOutIcon> = ({
  statusType,
  isGreyed,
}) => {
  const greyColor = greyMui._500;
  const colorOrange = isGreyed ? greyColor : rydeColors.passOutOrange;
  const colorBlue = isGreyed ? greyColor : rydeColors.passInBlue;
  return (
    <>
      {statusType === RideStationType.Out && (
        <SVG_MUI.StopRed3SVG fill={colorOrange} />
      )}
      {statusType === RideStationType.In && (
        <SVG_MUI.StopBlue3SVG fill={colorBlue} />
      )}
      {statusType === RideStationType.Both && isGreyed && (
        <SVG_MUI.StopBlueRedGreyed3SVG />
      )}
      {statusType === RideStationType.Both && !isGreyed && (
        <SVG_MUI.StopBlueRed3SVG />
      )}
    </>
  );
};
